// AdminFrontend/src/App.js
import React from "react";
import { BrowserRouter } from "react-router-dom";
import AdminApp from "./admin_ui/AdminApp";
import "./globals.css";

function App() {
  return (
    <BrowserRouter>
      <AdminApp />
    </BrowserRouter>
  );
}

export default App;
